module.exports = __webpack_public_path__ + "img/small-call.284551fd.svg";